
import React, { useEffect } from 'react';
import './App.css';
import Landing from './Pages/landing';
import { Box, Container } from '@chakra-ui/react';
import WithSubnavigation from './Components/NavBar';
import Hosts from './Pages/Hosts';
import {
  Switch,
  Route,
} from "react-router-dom";
import Hangouts from './Pages/Hangouts';
import Footer from './Components/Footer';
import Privacy from './Info Pages/Privacy';
import Contacts from './Pages/Contact';
import Terms from './Info Pages/Terms';
import DMCA from './Info Pages/DMCA';
import Guidelines from './Info Pages/Guidelines';
import mixpanel from 'mixpanel-browser';



function App() {

  useEffect(() => {
    mixpanel.init("90229453046442a35e4bde36f49b5958");
    mixpanel.track('Sign Up', {
      'source': "This is a test",
      'Test': true,
    });
  },[]);


  return (
    <>
    
        <WithSubnavigation/>

  
    <Box pt={["0px", "0px", "80px", "80px"]}>
      <Switch>
      <Route path="/" exact>
        <Landing/>
      </Route>
      <Route path="/hosts">
        <Hosts/>
      </Route>
      <Route path="/hangouts">
        <Hangouts/>
      </Route>
      <Route path="/contact">
        <Contacts/>
      </Route>
      <Route path="/privacy">
        <Privacy/>
      </Route>
      <Route path="/terms">
        <Terms/>
      </Route>
      <Route path="/dmca">
        <DMCA/>
      </Route>
      <Route path="/guidelines">
        <Guidelines/>
      </Route>
      </Switch>
      <Footer/>
    </Box>
  
      
    </>
  );
}

export default App;
